<template>
  <div class="animated revealUp">
      
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t('add') }} {{$tc('currency' , 2)}}</div>
      <router-link class="btn-blue" to="currencies">{{$tc('currency' , 2)}} {{ $tc('list', 2) }}</router-link>
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div
          v-for="(item, index) in Currencies"
          :key="index"
          v-if="item.fieldname !== 'curr_id'"
          class="col-lg-6 col-xl-4 align-self-center mb-4"
        >
          <div v-if="item.fieldname !== 'curr_is_active'">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <!-- @focus="onFocusHandler" -->
                <!-- :required="item.required" -->
                <input
                  placeholder="."
                  @focus="onFocusHandler"
                  :type="item.type"
                  :name="item.fieldname"
                  :id="item.fieldname"
                  v-validate="item.validation"
                  v-model="item.fieldvalue"
                />
                <label>{{ $tc(item.label, 1)}}</label>
              </div>
              <Tooltip :title="$t(item.tooltip)" />
            </div>
            <p class="error_message">
              <span
                v-if="submitted && errors.has(item.fieldname)"
              >{{ errors.first(`${item.fieldname}`) }}</span>
            </p>
          </div>
          <div v-if="item.fieldname === 'curr_is_active'">
            <div class="d-flex align-items-center">
              <label class="mb-0 mr-3">{{ $t('active') }}</label>
              <label class="ios-switch">
                <input type="checkbox" class="ios-checkbox" v-model="item.fieldvalue" />
                <span class="switch-slider"></span>
              </label>
            </div>
            <p class="error_message">
              <span></span>
            </p>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            class="btn-blue"
            @click.prevent.stop="onFinalSubmit(true)"
          >{{ $t('save') }}</button>
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(false)"
            type="submit"
            class="btn-blue"
          >{{ $t('saveaddmore') }}</button>
          <button @click.prevent.stop="onResetForm()" class="btn-black">{{ $t('reset') }}</button>
          <b-button class="btn-outline-grey" variant="default" to="currencies">{{ $t('cancel') }}</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Currencies from "@/helper/formJSONMaster/Currencies";

export default {
  data() {
    return {
      btenable: false,
      Currencies: Currencies.ms_currencies,
      // v-validate="'required|email'"
      submitted: false,
      Methods: Currencies.Methods
    };
  },
  beforeMount() {
    this.onResetForm();
  },
  mounted() {
    console.log("Currencies :", Currencies);
  },
  methods: {
    onFocusHandler: function() {
      // this.submitted = false;
    },
    onResetForm: function() {
      this.Currencies.map(x => {
        if (x.type === "text" || x.type === "date") {
          x.fieldvalue = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        }
      });
    },
    onFinalSubmit: function(redirect) {
      console.log("call submit :");
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          this.btenable = true;
          let body = this.getRequestBody("POST", this.Currencies, this.Methods);

          MasterService.GlobalRequest(body)
            .then(response => {
              this.btenable = false;
              const { data } = response;
              if (data.status) {
                this.onResetForm();
                if (redirect) {
                  this.$router.push({
                    path: "/master/currencies"
                  });
                }
              } else {
                // Show Error Message:
                this.$toasted.show(data.message);
                console.log("data.message :", data.message);
              }
            })
            .catch(error => {
              // Catch Error:
              console.log("Catch Error On onFinalSubmit :", error);
            });
        } else {
          console.log("else :");
        }
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/CurrencyComponents/addCurrency.vue